import type { User } from 'firebase/auth';

export function hasPasswordProvider(user: User | null | undefined): boolean {
  return Boolean(user?.providerData?.some((p) => p.providerId === 'password'));
}

export function hasGoogleProvider(user: User | null | undefined): boolean {
  return Boolean(user?.providerData?.some((p) => p.providerId === 'google.com'));
}

export function isSsoOnlyAccount(user: User | null | undefined): boolean {
  if (!user?.providerData?.length) return false;
  return hasPasswordProvider(user) === false;
}
